import { style } from 'typestyle'

export const FolderDetailHeader_Container = style({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: '24px',
})
